import { showroomApi } from './api';

export const getSizeMappings = async () =>
  showroomApi.QUERY_GET('/size-mappings')({
    headers: {
      'Accepts-Version': '2',
    },
  });
